import { ListItem } from "@tiptap/extension-list"

import { getPathiconListItemClassName } from "../../pathicon/richTextStyles"

export const PathiconListItem = ListItem.extend({
  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          getPathiconListItemClassName(element.getAttribute("class")),
        renderHTML: (attributes: Record<string, unknown>) => {
          const className = getPathiconListItemClassName(attributes.class)

          return className ? { class: className } : {}
        }
      }
    }
  }
})
